import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=8bf522b0&lang=postcss&scoped=true"
script.__scopeId = "data-v-8bf522b0"

export default script